import { Link, Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Chatbot from "@/components/Chatbot";
import ScrollToTop from "@/components/ScrollToTop";
import SaaSHeader from "@/components/SaaSHeader";
import Footer from "@/components/Footer";


export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>AlphaLabs — Soluções Digitais, ERP/CRM e Cibersegurança</title>
        <meta name="description" content="Desenvolvimento de sites, e-commerces, apps, jogos, ERP/CRM e serviços de cibersegurança. SaaS pronto para crescer." />
        <link rel="canonical" href="/" />
      </Helmet>
      
      <SaaSHeader />
      
      <main className="flex-1">
        <Outlet />
      </main>
      
      <Chatbot />

      <ScrollToTop />
      
      <Footer />
    </div>
  );
}